import { render } from "./SidebarUserCard.vue?vue&type=template&id=7856b987&scoped=true"
import script from "./SidebarUserCard.vue?vue&type=script&lang=js"
export * from "./SidebarUserCard.vue?vue&type=script&lang=js"

import "./SidebarUserCard.vue?vue&type=style&index=0&id=7856b987&scoped=true&lang=scss"
import "./SidebarUserCard.vue?vue&type=style&index=1&id=7856b987&lang=scss"

import exportComponent from "/Users/ramazansapar/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7856b987"]])

export default __exports__